module.exports = __webpack_public_path__ + "static/media/tachometer-average.8021c7b7.svg";